/* eslint-disable @typescript-eslint/naming-convention */

import { getMilliseconds, getSeconds } from 'src/app/utils/date-time.utils';
import { DistanceConfig } from './distance.config';

export type ShortDistanceConfigSpec = ShortDistanceConfig & DistanceConfig;

interface ShortDistanceConfig {
  sd_maxSpurious: number;
  sd_spuriousStationaryRadius: number; //TODO: FIND UNITS FOR THIS
}

//DO NOT REARRANGE THESE - they are referenced by index in the platform-specific code
export const ShortDistanceProdConfig: ShortDistanceConfigSpec = {
  desiredAccuracy: 10, // options are 0, 10, 100, 1000 for iOS (iOS only)
  stationaryRadius: 100,
  distanceFilter: 16, // iOS only (dynamic/ld_locationUpdateMeters for Android)
  isLongDistance: false,
  dwellSeconds: getSeconds(0, 3, 0),
  dwellMeters: 50,
  autoConfirmCount: -1,
  noLocationsTimeout: getMilliseconds(0, 5, 0), // must be > dwellSeconds
  verificationTimeout: getMilliseconds(0, 1, 0),
  nearMeters: 50,
  sd_maxSpurious: 3,
  sd_spuriousStationaryRadius: 150,
  periodicLocationSeconds: getSeconds(4, 0, 0),
  iosWakeupAfterMinutes: 120,
  inaccurateLocationMeters: 1000,
  latitudeShift: 0.4,
  cacheTimeout: getSeconds(0, 15, 0),
  httpRequestTimeout: getMilliseconds(0, 0, 90)
};
